import React from "react";
import "./ContactForm.scss";
import { contactForm__data } from "../../editComponents/other/formsData";

function ContactForm() {
  const { inputs, inputs_sec2, inputStyles, formTitle, formDescription } =
    contactForm__data;

  return (
    <div className="contactForm">
      <div className="contentSectionWrapper">
        <div className="contentSection">
          <div className="topSection">
            <div className="titleContainer">{formTitle}</div>
            <div className="formDescription">{formDescription}</div>
          </div>

          <form
            name="contactForm" // Nombre del formulario para Netlify
            method="POST"
            data-netlify="true" // Habilita la funcionalidad de Netlify
            data-netlify-honeypot="bot-field" // Campo honeypot para evitar spam
            className="inputsForm"
          >
            {/* Campo honeypot oculto */}
            <input type="hidden" name="form-name" value="contactForm" />

            {inputs.map((input, index) => (
              <div className="inputContainer" key={index}>
                <div className="inputTitle">
                  {input.title} {input.required && "*"}
                </div>
                <input
                  type={input.type}
                  placeholder={input.placeholder}
                  name={input.name}
                  required={input.required}
                  multiple={input.multiple}
                  accept={input.accept}
                  style={{
                    borderBottom: `1px solid ${inputStyles.inputBorderColor}`,
                  }}
                />
              </div>
            ))}

            {inputs_sec2.map((input, index) => (
              <div className="inputContainer" key={index}>
                <div className="inputTitle">
                  {input.title} {input.required && "*"}
                </div>
                <input
                  type={input.type}
                  placeholder={input.placeholder}
                  name={input.name}
                  required={input.required}
                  multiple={input.multiple}
                  accept={input.accept}
                  style={{
                    borderBottom: `1px solid ${inputStyles.inputBorderColor}`,
                  }}
                />
              </div>
            ))}

            <div className="inputContainer">
              <div className="inputTitle">
                If you have pictures or sketches, send them via email or
                WhatsApp below. This helps us provide better service!
              </div>
              <div className="contactIconsContainer">
                <a href="mailto:epoxy.drywall.andpaint@gmail.com?subject=Project Details">
                  <i className="fa-regular fa-envelope"></i>
                </a>
                <a
                  href="https://api.whatsapp.com/send/?phone=%2B14069462673"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa-brands fa-whatsapp"></i>
                </a>
              </div>
            </div>

            <button type="submit" className="submitButton">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
